/* @ngInject */
function btnLoading($interpolate, $filter) {
  return {
    restrict: "AC",
    scope: {
      btnLoading: "=",
    },
    link: function (scope, element, attr) {
      const content = element.text();

      scope.$watch("btnLoading", function (newVal, oldVal) {
        if (newVal !== oldVal) {
          if (newVal === true) {
            element.prop("disabled", true);
            element.html($filter("trans")("form.submit.saving"));
          } else {
            element.prop("disabled", false);
            element.html($interpolate(content));
          }
        }
      });
    },
  };
}

export default btnLoading;
